import React from 'react';
export default function Field({ label, children, required }) {
  return (
    <div style={{ marginBottom: 16 }}>
      <label style={{ display: 'block', fontSize: 13, fontWeight: 500, color: '#444', marginBottom: 6 }}>
        {label}{required && <span style={{ color: '#A32D2D', marginLeft: 3 }}>*</span>}
      </label>
      {children}
    </div>
  );
}
